<template>
  <div class="relationship-inactive-notice">
    <v-icon color="success" class="mr-2">fa-solid fa-circle-check</v-icon>
    <span v-if="product === 'uthrive'">
      <strong>This case is closed.</strong> You can still view past messages and
      resources here.
    </span>
    <span v-else>
      <strong>This case is closed.</strong> You can
      still view past messages and resources here.
    </span>
  </div>
</template>

<script>
export default {
  name: "RelationshipInactiveNotice",
  props: {
    product: { type: String, required: true }
  }
};
</script>

<style lang="scss" scoped>
.relationship-inactive-notice {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 14px;
}
</style>
